"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IterateObjectResponseTypes = void 0;
/**
 * Exclusively accepts items of type T or U, but not a mess of both.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Return an error or a result
 */
let IterateObjectResponseTypes;
exports.IterateObjectResponseTypes = IterateObjectResponseTypes;
(function (IterateObjectResponseTypes) {
  IterateObjectResponseTypes[IterateObjectResponseTypes["Continue"] = 0] = "Continue";
  IterateObjectResponseTypes[IterateObjectResponseTypes["Stop"] = 1] = "Stop";
})(IterateObjectResponseTypes || (exports.IterateObjectResponseTypes = IterateObjectResponseTypes = {}));